interface Props {
  isRTL: boolean;
}
const SvgMore: React.FC<Props> = ({ isRTL }) => {
  return (
    <svg
      style={isRTL ? { transform: "scaleX(-1)" } : {}}
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M6.6607 2.39413C6.54134 2.39417 6.4247 2.42979 6.32569 2.49646C6.22669 2.56313 6.14981 2.65781 6.1049 2.7684C6.05998 2.87898 6.04907 3.00045 6.07355 3.11728C6.09804 3.2341 6.1568 3.34096 6.24234 3.42421L11.8181 8.99999L6.24234 14.5758C6.18475 14.6311 6.13878 14.6973 6.10711 14.7706C6.07544 14.8438 6.0587 14.9227 6.05789 15.0025C6.05708 15.0823 6.0722 15.1615 6.10238 15.2354C6.13255 15.3093 6.17717 15.3765 6.23362 15.4329C6.29006 15.4894 6.35721 15.534 6.43111 15.5642C6.50502 15.5943 6.5842 15.6095 6.66403 15.6087C6.74385 15.6078 6.82271 15.5911 6.89599 15.5594C6.96927 15.5278 7.03549 15.4818 7.09077 15.4242L13.0908 9.42421C13.2033 9.31169 13.2664 9.1591 13.2664 8.99999C13.2664 8.84089 13.2033 8.6883 13.0908 8.57577L7.09077 2.57578C7.03486 2.5183 6.96799 2.47261 6.89413 2.44141C6.82026 2.41022 6.74088 2.39414 6.6607 2.39413Z"
          className="fill-current"
        />
      </g>
    </svg>
  );
};

export default SvgMore;
